<template>
    <div :class="className + ' form-group two gcrg10'">
        <label :for="id">{{ label }}</label>
        <div :class="'input-group two gcg10 ' + animationClass">
            <div class="input-group-prepend">
                <div class="input-group-text">{{ emoji }} {{ symbol }}</div>
            </div>
            <input type="number" min="0" step="1" :name="id" :id="id" class="form-control" :value="amount" :placeholder="placeholder" @keyup="$emit('input', $event.target.value)" :readonly="makeReadOnly">
        </div>
    </div>
</template>

<script>
    export default {
        name: "AmountComponent",
        props: {
            label: String,
            placeholder: String,
            id: String,
            helpText: String,
            className: '',
            required: false,
            validate: true,
            currency: '',
            amount: '',
            makeReadOnly: false,
            emoji: '',
            symbol: '',
        },
        data: () => ({
            animationClass: ''
        }),
        watch: {
            emoji: function(newVal, oldVal){
                this.animationClass = 'animate__animated animate__heartBeat';
                setTimeout(() =>  {
                    this.animationClass = '';
                }, 1500);
            }
        }
    }
</script>

<style scoped>

</style>
